
import { dig } from 'vessel/utils'

import cell from './mixins/cell'
import size from './mixins/size'

import Expand from './types/value/expand'
import Index from './types/value/index'
import Selection from './types/value/selection'

export default {
  name: 'VsTableColumn',
  mixins: [cell, size],
  components: {
    Expand,
    Index,
    Selection
  },
  inject: {
    tableRow: {
      default: {
        data: {},
        index: 0
      }
    }
  },
  props: {
    type: {
      type: String,
      default: null
    }
  },
  computed: {
    index() {
      return this.tableRow.index
    },
    row() {
      return this.tableRow.data
    },
    value() {
      return this.prop ? dig(this.row, this.prop) : undefined
    }
  }
}
